import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import lottie from "lottie-web";
import { useTranslation } from "react-i18next";

export default function Infos() {
  const [showPayButton, setShowPayButton] = useState(false);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    adresse: "",
    codePostal: "",
    ville: "",
  });
  const [error, setError] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});
  const [emailError, setEmailError] = useState("");
  const [email, setEmail] = useState("");

  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { paymentOrderID } = location.state || {};
  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);

    if (value.trim() === "") {
      setEmailError("L'email est obligatoire");
      setShowPayButton(false);
    } else if (!validateEmail(value)) {
      setEmailError("Veuillez entrer une adresse email valide");
      setShowPayButton(false);
    } else {
      setEmailError("");
      setShowPayButton(true);
    }
  };

  useEffect(() => {
    const fieldsReady = email.trim() !== "";
    setShowPayButton(fieldsReady && validateEmail(email.trim()));
  }, [email]);

  useEffect(() => {
    const animationContainer = document.getElementById("lottie-animation");

    const animation = lottie.loadAnimation({
      container: animationContainer,
      renderer: "svg",
      loop: false,
      autoplay: false,
      path: "/charging_animation.json",
    });
    return () => animation.destroy(); // Clean up on unmount
  }, []);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleStartCharging = async () => {
    if (!validateEmail(email)) {
      setEmailError("Veuillez entrer une adresse email valide.");
      return;
    }
    // if (showInvoiceFields) {
    //   const errors = {};
    //   if (!formData.first_name) errors.first_name = "Nom obligatoire";
    //   if (!formData.last_name) errors.last_name = "Prénom obligatoire";
    //   if (!formData.adresse) errors.adresse = "Adresse obligatoire";
    //   if (!formData.codePostal) errors.codePostal = "Code postal obligatoire";
    //   if (!formData.ville) errors.ville = "Ville obligatoire";

    //   if (Object.keys(errors).length > 0) {
    //     setFieldErrors(errors);
    //     return;
    //   }
    //   // const { first_name, last_name, adresse, codePostal, ville } = formData;
    //   // if (!first_name || !last_name || !adresse || !codePostal || !ville) {
    //   //   setError("⚠️ Veuillez remplir tous les champs de facturation.");
    //   //   return;
    //   // }
    // }

    setFieldErrors({});
    // continue your API call...
    // setError("");
    const payload = {
      email: email,
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/paygreen/charge-now-qovoltis-start-authorization?authorization_id=${paymentOrderID}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) throw new Error("Erreur lors de l'appel à l'API");
      navigate("/start-charging", {
        state: {
          paymentOrderID,
        },
      });
    } catch (err) {
      console.error(err);
      setError("❌ Une erreur est survenue. Veuillez réessayer.");
    }
  };

  return (
    <div className="bg-white flex flex-col min-h-screen p-4 pt-60 relative">
      <div className="flex-grow w-full max-w-lg mx-auto pb-75">
        {/* Keep all your existing content */}
        <div className="alert flex items-start gap-1 mb-6">
          <img
            src="/Check_Circle.svg"
            alt="check icon"
            className="icon mr-2"
          />
          <p className="text-info-message">
            {t("preAuthValidated")}
          </p>
        </div>
        <div className="alert flex items-start gap-1 mb-6">
          <img
            src="/Danger_Circle.svg"
            alt="Danger icon"
            className="icon mr-2"
          />
          <p className="text-info-message">
            {t("plugBeforePayment")}
          </p>
        </div>

        <div
          id="lottie-animation"
          style={{
            width: "300px",
            height: "100px",
            margin: "0 auto",
            marginTop: "10%",
          }}
        ></div>

        <p className="text-center text-xl font-medium mb-4">
          {t("chargingWillStart")}
        </p>
        {/* <div className="text-input-group mt-4 w-full">
          <label className="text-label">L'adresse e-mail est obligatoire</label>
          <input
            type="email"
            className={`styled-input ${emailError ? "border-red-500" : ""}`}
            value={email}
            onChange={handleEmailChange}
            required
          />
          {emailError && (
            <p className="text-red-500 text-xs mt-1">{emailError}</p>
          )}
          <p className="email-help-message">
            Votre e-mail est requis pour recevoir le reçu.
          </p>
        </div> */}
        <div className="mt-4 pt-4">
          <div className="max-w-lg mx-auto">
            <button
              onClick={handleStartCharging}
              className="payment-button"
              disabled={!showPayButton}
            >
              <span className="custom-button-text">{t("startCharging")}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
